import React, { useState, useEffect } from 'react';
import './index.scss';
import PropTypes from "prop-types";
import PSTabs from '../../PSTabs';
import { ButtonColor } from '../../atoms/button/Button';
import { Button, SelectCustom } from '../../atoms';
import PSIcon from '../../PSIcon';
import DropzoneCustom from '../../molecules/dropZoneCustom/dropZoneCustom';
import moment from "moment-timezone/index";
import {OPTION_SEGMENT} from "../../../../scripts/Constants";

const NameTab = ({ name, icon }) => {
  return (<div className="d-flex icon-container"><PSIcon type={icon}/><div className="title-tab"><h4>{name}</h4></div></div>)
};

const tabsCreateMngPromotions = [
  { id: 0, name: <NameTab name="Fotografias" icon="laptop" />, className: '', selected: true },
];

const tabsCreateMngPromotions2 = [
  { id: 0, name: 'Descripción', className: '', selected: true },
];

const CreateManagementGalley = React.forwardRef(({onSave, onChange, newPhoto, onClose, typeSelected, loadingSave}, ref) => {

  const [tabsCreateManagementPromotions, setTabsCreateManagementPromotions] = useState([...tabsCreateMngPromotions]);
  const [tabsCreateManagementPromotions2, setTabsCreateManagementPromotions2] = useState([...tabsCreateMngPromotions2]);
    const today = moment(Date.now()).format('YYYY-MM-DD');

  const isCompleted =()=>{

    let completedField = false;
    //
    // if(newPromotion.file && newPromotion.name && newPromotion.startDate && newPromotion.endDate){
    //   completedField = true;
    // }
    //
    // if(typeSelected===3){
    //   if(newPromotion.products && newPromotion.products.length>0){
    //     completedField = completedField && true;
    // }else{
    //     completedField = completedField && false;
    //   }
    // }
    // return completedField;
  }

  const onSelectTabCMP =(indexChange)=>{
    if(indexChange>=0){
      tabsCreateManagementPromotions.forEach((item,index)=>{
        if(index ===indexChange){
          item.selected = true;
        }else{
          item.selected = false;
        }
      });
      setTabsCreateManagementPromotions([...tabsCreateManagementPromotions]);
    }
  };

  const onSelectTabCMP2 =(indexChange2)=>{
    if(indexChange2>=0){
      tabsCreateManagementPromotions2.forEach((item,index)=>{
        if(index ===indexChange2){
          item.selected = true;
        }else{
          item.selected = false;
        }
      });
      setTabsCreateManagementPromotions2([...tabsCreateManagementPromotions2]);
    }
  };

  useEffect(() => {

  }, []);


  return (
    <div className="create-management-gallery" ref={ref}>
      <div className="body__validation">
        <div className="body__row">
          <div className="management-promotion-body-container">
            <h2 className="lc-title2">Subir archivos</h2>
            <PSTabs className="tabs-newsletter"
                    options={tabsCreateManagementPromotions}
                    onSelecTab={onSelectTabCMP}
                    hasFilters={false} hasButtonSubmit={false}
            />
            <div className="drop-area-container">
              <DropzoneCustom onChangeFile ={(file)=>{onChange('photo',file[0]); console.log("file-->>", file[0] ) }} acceptMultiple={typeSelected === 1}/>
            </div>
            <PSTabs className="tabs-newsletter"
                    options={tabsCreateManagementPromotions2}
                    onSelecTab={onSelectTabCMP2}
                    hasFilters={false} hasButtonSubmit={false}
            />
            <div className="options-container">
              <input id="description" onChange={(e)=>{onChange('description',e.target.value)}}/>
            </div>
            <div className="btns-container">
              <Button type={ButtonColor.blue} onClick={onSave} disabled={!isCompleted()} loading={loadingSave}>Publicar</Button>
              <Button className="ml-1 btn-close" type={ButtonColor.outline} onClick={onClose}>Cancelar</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

CreateManagementGalley.displayName = 'CreateManagementGalley';

CreateManagementGalley.defaultProps = {
  surveyCreate:{},
  onHandleCreateSurvey: ()=>{},
  onClose: () => {},
};

CreateManagementGalley.propTypes = {

  surveyCreate: PropTypes.object,
  onHandleCreateSurvey: PropTypes.func,
  onClose: PropTypes.func,
};

export default CreateManagementGalley;

